import { useSuspenseQuery } from "@tanstack/react-query";
import { getRouteApi } from "@tanstack/react-router";
import { getMerchantQuery } from "@/lib/merchant-query";

export { getMerchantQuery } from "@/lib/merchant-query";

const mainLayoutRoute = getRouteApi("/(app)/_main-layout");
export function useMerchant() {
  const context = mainLayoutRoute.useRouteContext();
  return useSuspenseQuery({
    ...getMerchantQuery({
      accessToken: context.accessToken,
      merchantId: context.merchantId,
    }),
    select: (data) => data.merchant,
  }).data;
}
